import { Alert } from '@mui/material';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './styles.module.css';

@autobind
export default class Message extends Component {
    static propTypes = {
        className: PropTypes.string,
        children: PropTypes.node.isRequired,
        type: PropTypes.oneOf(['success', 'warning', 'danger', 'info', 'muted', 'theme']).isRequired,
        appearance: PropTypes.oneOf(['outline', 'fill', 'fixed']),
        showIcon: PropTypes.bool,
        theme: PropTypes.oneOf(['cultivio', 'latijereta', 'agroceres', 'agroeste', 'md', 'expertobayer', 'fieldview']),
        color: PropTypes.oneOf(['red']),
        responsive: PropTypes.bool,
        fixed: PropTypes.bool,
    };

    static defaultProps = {
        appearance: 'outline',
        showIcon: false,
        responsive: false,
    };

    render() {
        const { children, type, appearance, showIcon, className, theme, color, responsive, fixed } = this.props;
        const icon = showIcon && this.getIconByType(type);
        const rootClassNames = classNames(
            className,
            styles.root,
            styles[`appearance-${appearance}`],
            // styles[`type-${type === 'theme' ? theme : type}`],
            styles[`color-${color}`],
            responsive && styles.responsive,
            fixed && styles.fixed
        );

        return (
            <div className={rootClassNames}>
                <div className={responsive && styles.icon}>{icon && <i className='material-icons'>{icon}</i>}</div>
                <div className={responsive && styles.children}>{children}</div>
            </div>
        );
    }

    getIconByType(type) {
        return {
            success: 'done',
            warning: 'warning',
            danger: 'error',
            info: 'info',
            theme: 'info',
        }[type];
    }
}
